import { AlertModel } from "../models/alertModel"
import { Element } from "../models/elementModel"
import { ElementTemplate } from "../models/elementTemplateModel"
import { Form } from "../models/formModel"
import { ModalModel } from "../models/modalModel"
import { Project } from "../models/projectModel"
import { Prototype } from "../models/prototypeModel"
import { Row } from "../models/rowModel"
import { Section } from "../models/sectionModel"
import { Session } from "../models/sessionModel"
import { TabModel } from "../models/tabModel"

export const ADD_ROW = "ADD_ROW"
export const ADD_ROW_LIST = "ADD_ROW_LIST"
export const EDIT_ROW = "EDIT_ROW"
export const REMOVE_ROW = "REMOVE_ROW"
export const REMOVE_ROW_LIST = "REMOVE_ROW_LIST"
export const REMOVE_ROW_LIST_BY_FORM_ID = "REMOVE_ROW_LIST_BY_FORM_ID"
export const REMOVE_ALL_ROWS = "REMOVE_ALL_ROWS"
export const REMOVE_ROW_BY_TAB_ID = "REMOVE_ROW_BY_TAB_ID"
export const SET_ROW = "SET_ROW"
export const MOVE_ROW = "MOVE_ROW"
export const ADD_ELEMENT = "ADD_ELEMENT"
export const ADD_ELEMENT_LIST = "ADD_ELEMENT_LIST"
export const EDIT_ELEMENT = "EDIT_ELEMENT"
export const REMOVE_ELEMENT = "REMOVE_ELEMENT"
export const REMOVE_ELEMENT_LIST = "REMOVE_ELEMENT_LIST"
export const REMOVE_ELEMENT_LIST_BY_FORM_ID = "REMOVE_ELEMENT_LIST_BY_FORM_ID"
export const REMOVE_ELEMENT_BY_SECTION_ID = "REMOVE_ELEMENT_BY_SECTION_ID"
export const MOVE_ELEMENT = "MOVE_ELEMENT"
export const MOVE_ELEMENT_SECTION = "MOVE_ELEMENT_SECTION"
export const COPY_ELEMENT = "COPY_ELEMENT"
export const DROP_ELEMENT = "DROP_ELEMENT"
export const COPY_TABLE_CELL_ELEMENTS = "COPY_TABLE_CELL_ELEMENTS"
export const REMOVE_ALL_ELEMENTS = "REMOVE_ALL_ELEMENTS"
export const SET_ELEMENT = "SET_ELEMENT"
export const EDIT_SESSION = "EDIT_SESSION"
export const SET_SESSION = "SET_SESSION"
export const ADD_FORM = "ADD_FORM"
export const EDIT_FORM = "EDIT_FORM"
export const REMOVE_FORM = "REMOVE_FORM"
export const SET_FORM = "SET_FORM"
export const REMOVE_ALL_FORMS = "REMOVE_ALL_FORMS"
export const SET_ELEMENT_TEMPLATE = "SET_ELEMENT_TEMPLATE"
export const ADD_SECTION = "ADD_SECTION"
export const ADD_SECTION_LIST = "ADD_SECTION_LIST"
export const EDIT_SECTION = "EDIT_SECTION"
export const REMOVE_SECTION = "REMOVE_SECTION"
export const REMOVE_SECTION_LIST = "REMOVE_SECTION_LIST"
export const REMOVE_SECTION_LIST_BY_FORM_ID = "REMOVE_SECTION_LIST_BY_FORM_ID"
export const SET_SECTION = "SET_SECTION"
export const MOVE_SECTION = "MOVE_SECTION"
export const DROP_SECTION = "DROP_SECTION"
export const REMOVE_ALL_SECTIONS = "REMOVE_ALL_SECTIONS"
export const ADD_TAB = "ADD_TAB"
export const ADD_TAB_LIST = "ADD_TAB_LIST"
export const EDIT_TAB = "EDIT_TAB"
export const REMOVE_TAB = "REMOVE_TAB"
export const REMOVE_TAB_LIST = "REMOVE_TAB_LIST"
export const REMOVE_TAB_LIST_BY_FORM_ID = "REMOVE_TAB_LIST_BY_FORM_ID"
export const SET_TAB = "SET_TAB"
export const REMOVE_ALL_TABS = "REMOVE_ALL_TABS"
export const SET_PROTOTYPE = "SET_PROTOTYPE"
export const EDIT_PROTOTYPE = "EDIT_PROTOTYPE"
export const SET_MODAL = "SET_MODAL"
export const EDIT_MODAL = "EDIT_MODAL"
export const SET_ALERT = "SET_ALERT"
export const EDIT_ALERT = "EDIT_ALERT"
export const SET_PROJECT = "SET_PROJECT"
export const EDIT_PROJECT = "EDIT_PROJECT"
export const SET_ACTIVE_PATH = "SET_ACTIVE_PATH"


export interface AddRowAction {
    type: typeof ADD_ROW;
    row: Row;
}

export interface AddRowListAction {
    type: typeof ADD_ROW_LIST;
    rows: Row[];
}

export interface EditRowAction {
    type: typeof EDIT_ROW;
    row: Row;
}

export interface RemoveRowAction {
    type: typeof REMOVE_ROW;
    id: String;
}

export interface RemoveRowListAction {
    type: typeof REMOVE_ROW_LIST;
    rows: Row[];
}

export interface RemoveRowListByFormIdAction {
    type: typeof REMOVE_ROW_LIST_BY_FORM_ID;
    formId: String;
}

export interface RemoveAllRowsAction {
    type: typeof REMOVE_ALL_ROWS;
    rows: Row[];
}

export interface SetRowAction {
    type: typeof SET_ROW;
    rows: Row[];
}

export interface MoveRowAction {
    type: typeof MOVE_ROW;
    rowDrag: Row;
    rowDrop: Row;
}

export interface AddElementAction {
    type: typeof ADD_ELEMENT;
    element: Element;
}

export interface AddElementListAction {
    type: typeof ADD_ELEMENT_LIST;
    elements: Element[];
}

export interface EditElementAction {
    type: typeof EDIT_ELEMENT;
    element: Element;
}

export interface RemoveElementAction {
    type: typeof REMOVE_ELEMENT;
    id: String;
}

export interface RemoveElementListAction {
    type: typeof REMOVE_ELEMENT_LIST;
    elements: Element[];
}

export interface RemoveElementByFormIdAction {
    type: typeof REMOVE_ELEMENT_LIST_BY_FORM_ID;
    formId: String;
}

export interface RemoveElementBySectionIdAction {
    type: typeof REMOVE_ELEMENT_BY_SECTION_ID;
    id: String;
}

export interface MoveElementAction {
    type: typeof MOVE_ELEMENT;
    elementDrag: Element;
    elementDrop: Element;
}

export interface MoveElementSectionAction {
    type: typeof MOVE_ELEMENT_SECTION;
    elementDrag: Element;
    elementDrop: Element;
}

export interface DropElementAction {
    type: typeof DROP_ELEMENT;
    element: Element;
    newSectionId: String
}

export interface CopyElementAction {
    type: typeof COPY_ELEMENT;
    element: Element;
    originalElement: Element
}

export interface CopyTableCellElementsAction {
    type: typeof COPY_TABLE_CELL_ELEMENTS;
    elements: Element[];
}

export interface RemoveAllElementsAction{
    type: typeof REMOVE_ALL_ELEMENTS;
    elements : Element[]
}

export interface SetElementAction {
    type: typeof SET_ELEMENT;
    elements: Element[];
}

export interface EditSessionAction {
    type: typeof EDIT_SESSION;
    session: Session;
}
export interface SetSessionAction {
    type: typeof SET_SESSION;
    session: Session;
}

export interface AddFormAction {
    type: typeof ADD_FORM;
    form: Form;
}

export interface EditFormAction {
    type: typeof EDIT_FORM;
    form: Form;
}

export interface RemoveFormAction {
    type: typeof REMOVE_FORM;
    id: String;
}

export interface SetFormAction {
    type: typeof SET_FORM;
    forms: Form[];
}

export interface RemoveAllForms {
    type: typeof REMOVE_ALL_FORMS;
}
export interface SetElementTemplateAction {
    type: typeof SET_ELEMENT_TEMPLATE;
    elementTemplates: ElementTemplate[];
}

export interface AddSectionAction {
    type: typeof ADD_SECTION;
    section: Section;
}

export interface AddSectionListAction {
    type: typeof ADD_SECTION_LIST;
    sections: Section[];
}

export interface EditSectionAction {
    type: typeof EDIT_SECTION;
    section: Section;
}

export interface RemoveSectionAction {
    type: typeof REMOVE_SECTION;
    id: String;
}

export interface RemoveSectionListAction {
    type: typeof REMOVE_SECTION_LIST;
    sections: Section[];
}

export interface RemoveSectionListByFormIdAction {
    type: typeof REMOVE_SECTION_LIST_BY_FORM_ID;
    formId: String;
}

export interface SetSectionAction {
    type: typeof SET_SECTION;
    sections: Section[];
}

export interface MoveSectionAction {
    type: typeof MOVE_SECTION;
    sectionDrag: Section;
    sectionDrop: Section;
}

export interface DropSectionAction {
    type: typeof DROP_SECTION;
    section: Section;
    newRowId: String
}

export interface RemoveAllSectionsAction {
    type: typeof REMOVE_ALL_SECTIONS;
    sections: Section[]
}
export interface AddTabAction {
    type: typeof ADD_TAB;
    tab: TabModel;
}

export interface AddTabListAction {
    type: typeof ADD_TAB_LIST;
    tabs: TabModel[];
}
export interface EditTabAction {
    type: typeof EDIT_TAB;
    tab: TabModel;
}

export interface RemoveTabAction {
    type: typeof REMOVE_TAB;
    id: String;
}

export interface RemoveTabListAction {
    type: typeof REMOVE_TAB_LIST;
    tabs: TabModel[];
}

export interface RemoveTabListByFormIdAction {
    type: typeof REMOVE_TAB_LIST_BY_FORM_ID;
    formId: String;
}

export interface SetTabAction {
    type: typeof SET_TAB;
    tabs: TabModel[];
}

export interface RemoveAllTabsAction {
    type: typeof REMOVE_ALL_TABS;
    tabs: TabModel[];
}

export interface EditPrototypeAction {
    type: typeof EDIT_PROTOTYPE;
    protoType: Prototype;
}

export interface SetPrototypeAction {
    type: typeof SET_PROTOTYPE;
    protoType: Prototype;
}

export interface EditModalAction {
    type: typeof EDIT_MODAL;
    modal: ModalModel;
}

export interface SetModalAction {
    type: typeof SET_MODAL;
    modal: ModalModel;
}

export interface EditAlertAction {
    type: typeof EDIT_ALERT;
    alert: AlertModel;
}

export interface SetAlertAction {
    type: typeof SET_ALERT;
    alert: AlertModel;
}

export interface SetProjectAction {
    type: typeof SET_PROJECT;
    projects: Project[];
}

export interface EditProjectAction {
    type: typeof EDIT_PROJECT;
    project: Project;
}

export interface SetActivePathAction {
    type: typeof SET_ACTIVE_PATH;
    path: string;
}


export type RowActionTypes =
    | SetRowAction
    | RemoveRowAction
    | AddRowAction
    | AddRowListAction
    | MoveRowAction
    | EditRowAction
    | RemoveRowListAction
    | RemoveRowListByFormIdAction
    | RemoveAllRowsAction;

export type ElementActionTypes = SetElementAction | RemoveElementAction | EditElementAction | AddElementAction | AddElementListAction | MoveElementAction | MoveElementSectionAction | DropElementAction | RemoveElementBySectionIdAction | RemoveElementListAction | CopyElementAction | CopyTableCellElementsAction | RemoveElementByFormIdAction | RemoveAllElementsAction;

export type SessionActionTypes = SetSessionAction | EditSessionAction;

export type FormActionTypes = SetFormAction | RemoveFormAction | EditFormAction | AddFormAction | RemoveAllForms;

export type ElementTemplateActionTypes = SetElementTemplateAction;

export type SectionActionTypes = SetSectionAction | RemoveSectionAction | AddSectionAction | AddSectionListAction | MoveSectionAction | DropSectionAction | EditSectionAction | RemoveSectionListAction | RemoveSectionListByFormIdAction | RemoveAllSectionsAction;

export type TabActionTypes = AddTabAction | AddTabListAction | EditTabAction | RemoveTabAction | RemoveTabListAction | SetTabAction | RemoveTabListByFormIdAction | RemoveAllTabsAction;

export type ProtoTypeActionTypes = SetPrototypeAction | EditPrototypeAction;

export type ModalActionTypes = SetModalAction | EditModalAction;

export type AlertActionTypes = SetAlertAction | EditAlertAction;

export type ProjectActionTypes = SetProjectAction | EditProjectAction;

export type ActivePathActionTypes = SetActivePathAction;

export type AppActions = RowActionTypes | ElementActionTypes | SessionActionTypes | FormActionTypes | ElementTemplateActionTypes | SectionActionTypes | TabActionTypes | ProtoTypeActionTypes | ModalActionTypes | AlertActionTypes | ProjectActionTypes | ActivePathActionTypes;